import Button from '@components/common/Button'
import GridGallery from '@libs/slider/GridGallery'

interface IDetailsLayoutSection {
  title?: string
  subtitle?: string
  sliderComponents: JSX.Element[]
  onButtonClick?: any
}

const DetailsLayoutSection = ({
  title,
  subtitle,
  sliderComponents,
  onButtonClick,
}: IDetailsLayoutSection): JSX.Element => {
  return (
    <>
      {title && (
        <h3 className='mb-2 pr-5 text-h6 font-medium desktop:pr-0'>{title}</h3>
      )}
      {subtitle && (
        <p className='mb-[26px] pr-5 text-p14 font-normal text-darkgray desktop:pr-0 desktop:text-p'>
          {subtitle}
        </p>
      )}
      <GridGallery
        key={`${title}_section`}
        components={sliderComponents}
        responsiveGridConfig={{
          desktop: {
            itemsPerRow: 1,
            itemHeight: 350,
          },
          desktopSmall: {
            itemsPerRow: 1,
            itemHeight: 280,
          },
          tablet: {
            itemsPerRow: 1,
            itemHeight: 320,
          },
          mobile: {
            itemsPerRow: 1,
            itemHeight: 600,
          },
        }}
      />
      <div className='hidden mt-[3.125rem] w-[20.25rem] desktop:block'>
        <Button onClick={onButtonClick} variant='tertiary'>
          <>View All Options</>
        </Button>
      </div>
    </>
  )
}

export default DetailsLayoutSection
